export enum ReleasePlatformType {
  IOS = 'ios',
  ANDROID = 'android',
}
